export const USER_STATUS = {
  BOUND: 'Bound',
}
